import { render, staticRenderFns } from "./SolutionAccordion.vue?vue&type=template&id=43176a88&scoped=true"
import script from "./SolutionAccordion.vue?vue&type=script&lang=js"
export * from "./SolutionAccordion.vue?vue&type=script&lang=js"
import style0 from "./SolutionAccordion.vue?vue&type=style&index=0&id=43176a88&prod&scoped=true&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43176a88",
  null
  
)

export default component.exports